import api from './api';

const projectService = {
  // Get all projects with filters
  getAllProjects: async (params = {}) => {
    const response = await api.get('/projects', { params });
    // API returns { projects: [...], pagination: {...} }
    // Return as-is for ProjectList component
    return {
      projects: response.data.projects || [],
      pagination: response.data.pagination || {}
    };
  },

  // Get project by ID
  getProjectById: async (id) => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  // Create new project
  createProject: async (projectData) => {
    const response = await api.post('/projects', projectData);
    return response.data;
  },

  // Update project
  updateProject: async (id, projectData) => {
    const response = await api.put(`/projects/${id}`, projectData);
    return response.data;
  },

  // Delete project
  deleteProject: async (id) => {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },

  // Get project members
  getProjectMembers: async (id) => {
    const response = await api.get(`/projects/${id}/members`);
    return response.data;
  },

  // Add project member
  addProjectMember: async (id, memberData) => {
    const response = await api.post(`/projects/${id}/members`, memberData);
    return response.data;
  },

  // Get project tasks
  getProjectTasks: async (id) => {
    const response = await api.get(`/projects/${id}/tasks`);
    return response.data;
  },

  // Get project statistics
  getProjectStatistics: async (id) => {
    const response = await api.get(`/projects/${id}/statistics`);
    return response.data;
  },

  getProjectMilestones: async (id,status) => {
    const response = await api.get(`/projects/${id}/milestones`, {
      params: { status }
    });
    return response.data;
  },
};

export default projectService;


